import type { Enduser } from "@tellescope/types-models";
import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Label } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { FieldDescription } from "../../FieldDescription";
import type { TellescopeFormFieldBaseProps, TellescopeFieldResponse } from "../../types";
import {
  CANDID_ELIGIBILITY_VENDOR,
  EligibilityFieldContent,
  EligibilityStaffPanel,
  useEligibilityField,
} from "../EligibilityField";

export interface CandidEligibilityFieldProps extends TellescopeFormFieldBaseProps<"Candid Eligibility"> {
  enduserId: string;
  enduser?: TellescopeModelFromName<"endusers"> | Enduser;
  priorResponses: TellescopeFieldResponse[];
  sessionType?: "enduser" | "user";
  formResponseId?: string;
}

export const CandidEligibilityField = ({
  title,
  description,
  htmlDescription,
  value,
  onChange,
  options,
  enduserId,
  enduser,
  priorResponses,
  className,
  error,
  sessionType = "enduser",
  formResponseId,
}: CandidEligibilityFieldProps) => {
  const { phase, displayStatus, payerName, payerId, memberId, errorMessage, responseErrors, isChecking, triggerCheck } =
    useEligibilityField<"Candid Eligibility">({
      vendor: CANDID_ELIGIBILITY_VENDOR,
      value,
      onChange,
      options,
      enduserId,
      enduser,
      priorResponses,
      sessionType,
      formResponseId,
    });

  return (
    <div className={cn("space-y-1", className)}>
      {!!title && <Label required={false}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      {sessionType === "user" ? (
        <EligibilityStaffPanel
          serviceCode={options?.candidServiceCode}
          npi={options?.candidNPI}
          payerId={payerId}
          memberId={memberId}
          isChecking={isChecking}
          errorMessage={errorMessage}
          responseErrors={responseErrors}
          value={value}
          onCheck={triggerCheck}
        />
      ) : (
        <EligibilityFieldContent phase={phase} displayStatus={displayStatus} payerName={payerName} />
      )}
      {!!error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
